module.exports = __webpack_public_path__ + "static/media/PropertyEnrolment – Arabic@2x.6e866569.jpg";